import { useState } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/transitional/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { H4 } from 'foundations-components/transitional/components/H4';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { reportErrorToLogFetch } from 'academy-common-lib/utils/errorUtils';
import PracticalExerciseWrapper from './PracticalExerciseWrapper';
import PracticalExerciseRetryButtonContainer from './PracticalExerciseRetryButtonContainer';
import { useLoadPracticalExerciseSurvey } from '../practicalExerciseHooks';
import { usePracticalExercisePortalId } from '../practicalExerciseQueries';
import { ContactUsLink } from '../../../components/ContactUsLink';
import { Metrics } from '../../../Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const InProgressPracticalExercise = ({
  exercise,
  advanceToNextContent,
  contentId,
  exerciseTypeLabel = 'none',
  lessonId,
  trackId,
  onResumeExercise
}) => {
  const [loading, setLoading] = useState(false);
  const {
    getOrCreatePortal,
    portalIdLoading,
    isSimulationExercise,
    isSimulationGateLoading
  } = usePracticalExercisePortalId(Number(contentId), trackId);
  useLoadPracticalExerciseSurvey({
    skip: !isSimulationExercise
  });
  const handleResumeClick = () => {
    var _getOrCreatePortal;
    if (!isSimulationExercise) {
      onResumeExercise();
      return;
    }
    setLoading(true);
    (_getOrCreatePortal = getOrCreatePortal()) === null || _getOrCreatePortal === void 0 || _getOrCreatePortal.then(response => {
      var _response$data;
      Metrics.counter('exercise-content-mutation', {
        action: 'practical-exercise-portal-get-or-created',
        exerciseType: exerciseTypeLabel
      }).increment();
      onResumeExercise(response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.createPortal) === null || _response$data === void 0 ? void 0 : _response$data.portalId);
    }).catch(error => {
      Metrics.counter('exercise-mutation-call-error', {
        action: 'practical-exercise-portal-get-or-create-error',
        exerciseType: exerciseTypeLabel
      }).increment();
      reportErrorToLogFetch({
        loggingTitle: 'Practical Exercise Portal Get or Create Error',
        action: 'practical-exercise-portal-get-or-create-error',
        error,
        additionalData: {
          contentId,
          lessonId,
          trackId
        }
      });
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.practicalExercise.portalCreateError",
          options: {
            contactUsLink: /*#__PURE__*/_jsx(ContactUsLink, {})
          }
        })
      });
    }).finally(() => setLoading(false));
  };
  const instructionBody = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H4, {
      children: exercise.name
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "learningCenter.practicalExercise.instructions.inProgress.top.manual"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.instructions.inProgress.top.certified"
      })
    }), isSimulationExercise && /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.simulation.playgroundWillOpen"
      }), /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.simulation.progressReset"
        })
      })]
    })]
  });
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "in-progress-practical-exercise",
    children: /*#__PURE__*/_jsx(PracticalExerciseWrapper, {
      buttons: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(View, {
          marginInlineEnd: "300",
          children: /*#__PURE__*/_jsx(PracticalExerciseRetryButtonContainer, {
            contentId: contentId,
            "data-test-id": "practical-exercise-retry-button",
            exerciseTypeLabel: exerciseTypeLabel,
            lessonId: lessonId,
            trackId: trackId,
            use: "tertiary-light"
          })
        }), /*#__PURE__*/_jsx(LoadingButton, {
          "data-test-id": "practical-exercise-resume-button",
          external: true,
          loading: loading || portalIdLoading || isSimulationGateLoading,
          onClick: handleResumeClick,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.external.started.exerciseLink"
          })
        }), /*#__PURE__*/_jsx(Button, {
          marginInlineStart: "300",
          onClick: advanceToNextContent,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.next"
          })
        })]
      }),
      isStarted: true,
      children: /*#__PURE__*/_jsx(View, {
        marginBlock: "1000",
        minBlockSize: "300px",
        paddingInlineStart: "1000",
        children: instructionBody
      })
    })
  });
};
export default InProgressPracticalExercise;